import notificationEmail from './service';
export default {
    notificationEmail
};